import { Controller } from "@hotwired/stimulus"
import { number, percent } from "../../lib/format"

const STOPWORDS = new Set(("a an and are as at be but by for from has have he her his i if in is it its " +
  "me my no not of on or our she so that the their them then there these they this to us was we were " +
  "what when which who will with would you your").split(" "))

// Word and two-word phrase frequency for a block of text.
export default class extends Controller {
  static targets = ["text", "stopwords", "total", "unique", "words", "phrases"]

  analyse() {
    const words = this.textTarget.value.toLowerCase().match(/[\p{L}\p{N}][\p{L}\p{N}'’-]*/gu) || []
    const total = words.length
    const skip = this.stopwordsTarget.checked ? STOPWORDS : new Set()

    this.totalTarget.textContent = number(total)
    this.uniqueTarget.textContent = number(new Set(words).size)

    const kept = words.filter(w => !skip.has(w))
    this.fill(this.wordsTarget, tally(kept), total)

    const phrases = []
    for (let i = 0; i < words.length - 1; i++) {
      if (skip.has(words[i]) || skip.has(words[i + 1])) continue
      phrases.push(`${words[i]} ${words[i + 1]}`)
    }
    this.fill(this.phrasesTarget, tally(phrases), total)
  }

  fill(table, counts, total) {
    const rows = [...counts.entries()].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0])).slice(0, 10)
    const body = table.tBodies[0]
    body.replaceChildren()
    for (const [term, count] of rows) {
      const tr = body.insertRow()
      tr.insertCell().textContent = term
      tr.insertCell().textContent = number(count)
      tr.insertCell().textContent = percent(count / total)
    }
  }
}

function tally(items) {
  const counts = new Map()
  for (const item of items) counts.set(item, (counts.get(item) || 0) + 1)
  return counts
}
